import { delegatedObserver } from '../dom/dom';
import { Subscription } from 'rxjs';
import { JSONSchema7,  } from 'json-schema';
import { ProbeDefinition } from './probes';

export interface TLMDFormDefinition extends JSONSchema7 {
	properties?: {
		[key: string]: ProbeDefinition //JSONSchema7Definition & {	probe?:string };
	} | undefined;
	tlmd?: {
		caption?: TLMDFormCaptionOptions
	}
}

interface TLMDFormCaptionOptions {
	show: boolean,
	showDescription: boolean,
	showDescriptionPermanent: boolean
}

export class TLMDForm {
	private def: TLMDFormDefinition;
	private container: HTMLDivElement;
	private subscriptions: Subscription[] = [];

	private messageContainer: HTMLElement;
	private messageTimerHandle: any;

	public constructor(private containerSelector: string, options: TLMDFormDefinition) {
		this.def = this.fixOptions(options);

		this.container = document.querySelector(this.containerSelector);

		if (this.container) {
			this.initCaptionSection();
			this.initMessageSection();
			//make foldout sections work  
			this.subscriptions.push(delegatedObserver(this.container, 'click', 'div.tlmd-foldout-container a.tlmd-foldout')
				.subscribe(evAndTrgt => {
					evAndTrgt.event.preventDefault();
					evAndTrgt.target.blur();
					let foldoutContainerElem = evAndTrgt.target.closest('div.tlmd-foldout-container');
					if (foldoutContainerElem) {
						foldoutContainerElem.classList.toggle('folded');
					}
				}));

		} else {
			throw `Form container ${this.containerSelector} does not exist`;
		}
	}

	public release(): void {
		this.subscriptions.forEach(subscription => subscription.unsubscribe());
	}

	private initMessageSection(): void {
		this.messageContainer = <HTMLDivElement>this.container.querySelector('div.tlmd-form-message');
		if (this.messageContainer) {
			this.messageContainer.children[0].className = '';
			this.messageContainer.children[0].children[1].innerHTML = '';
			this.messageContainer.classList.remove('open');
			this.subscriptions.push(delegatedObserver(this.messageContainer, 'click', 'a.tlmd-close')
				.subscribe(evAndTrgt => {
					evAndTrgt.event.preventDefault();
					evAndTrgt.target.blur();
					this.messageContainer.classList.remove('open');
					if (this.messageTimerHandle) {
						window.clearTimeout(this.messageTimerHandle);
						this.messageTimerHandle = undefined;
					}
				}));
		}
	}

	protected showMessage(content: string, styleClass: string, timeout: number): void {
		if (this.messageContainer) {
			if (this.messageTimerHandle) {
				window.clearTimeout(this.messageTimerHandle);
				this.messageTimerHandle = undefined;
			}
			this.messageContainer.children[0].className = styleClass ? styleClass : '';
			this.messageContainer.children[0].children[1].innerHTML = content;
			this.messageContainer.classList.add('open');
			if (timeout != undefined && timeout > 0) {
				let self = this;
				this.messageTimerHandle = window.setTimeout(() => {
					self.messageContainer.classList.remove('open');
				}, timeout);
			}
		}
	}

	private initCaptionSection(): void {
		let captionContainer = <HTMLDivElement>this.container.querySelector('div.tlmd-form-caption');
		if (captionContainer) {
			if (!this.def.tlmd.caption.show) {
				captionContainer.style.display = 'none';
			} else {
				if (this.def.tlmd.caption.showDescription) {
					captionContainer.classList.remove('folded');
				}
				if (this.def.tlmd.caption.showDescriptionPermanent) {
					(<HTMLAnchorElement>captionContainer.querySelector('a.tlmd-foldout')).style.display = 'none';
				}
			}
		}
	}

	private fixOptions(def: TLMDFormDefinition): TLMDFormDefinition {
		if( def.tlmd == undefined ) def.tlmd = {};
		def.tlmd.caption = this.fixCaptionOptions(def);
		return def;
	}

	private fixCaptionOptions(def: TLMDFormDefinition): TLMDFormCaptionOptions {
		if (def.tlmd.caption == undefined) {
			return { show: false, showDescription: false, showDescriptionPermanent: true };
		} else {
			let titleAvailable = def.title && def.title.length > 0;
			let descriptionAvailable = def.description && def.description.length > 0;
			if (def.tlmd.caption.show !== false && titleAvailable) {
				//show caption
				def.tlmd.caption.show = true;
				if (descriptionAvailable) {
					if (def.tlmd.caption.showDescription !== true) {
						//initially hide description
						def.tlmd.caption.showDescription = false;
						def.tlmd.caption.showDescriptionPermanent = false;
					} else {
						//initially show description
						if (def.tlmd.caption.showDescription !== true) {
							//make the display of the description optional
							def.tlmd.caption.showDescriptionPermanent = false;
						}
					}
				} else {
					//no description available
					def.tlmd.caption.showDescription = false;
					def.tlmd.caption.showDescriptionPermanent = true;
				}
			} else {
				// hide caption
				def.tlmd.caption.showDescription = false;
				def.tlmd.caption.showDescriptionPermanent = false;
			}
			return def.tlmd.caption;
		}
	}

	public getDefinition(): TLMDFormDefinition {
		return this.def;
	}

}